import { createAction } from '@mews/framework';
import { CommanderThunkAction, WithScope } from '@mews-commander/types';
import { CHANGE_TAB } from '../actionTypes';
import { ReservationTab } from '../../../types/reservationTab';
import { openModal } from '../../app/actions/common';
import { getBillingGroupUrl } from '../../navigation/billing';
import { getCheckedReservationIds } from '../selectors';
import { compressToBase64 } from '../../app/components/TemplateFetcher/TemplateFetcher';

const RESERVATION_TAB_ROUTE_PATH_MAP = {
    [ReservationTab.Status]: './Status' as const,
    [ReservationTab.Properties]: './Properties' as const,
    [ReservationTab.Group]: './Group' as const,
    [ReservationTab.Pricing]: './Pricing' as const,
    [ReservationTab.Items]: './Items' as const,
    [ReservationTab.Mailing]: './Mailing' as const,
    [ReservationTab.ActionLog]: './ActionLog' as const,
    [ReservationTab.Summary]: './Summary' as const,
    [ReservationTab.Billing]: './Billing' as const,
    [ReservationTab.Contracts]: './Contracts' as const,
};
export const changeTab =
    ({ scope, reservationTab }: { reservationTab: ReservationTab } & WithScope): CommanderThunkAction =>
    async (dispatch, getState, { navigate }) => {
        if (reservationTab === ReservationTab.Billing) {
            const state = getState();

            const groupBillingUrl = getBillingGroupUrl(state, { groupId: scope });

            dispatch(openModal(groupBillingUrl));
        } else {
            dispatch(createAction(CHANGE_TAB, reservationTab, { scope }));
            await navigate({
                from: '/$currentEnterpriseId/Reservation/Detail/$reservationId',
                to: RESERVATION_TAB_ROUTE_PATH_MAP[reservationTab],
                search: true,
            });
            if (reservationTab === ReservationTab.Contracts) {
                const state = getState();
                const reservationIds = getCheckedReservationIds(state, { scope });
                void navigate({
                    to: '.',
                    search: (s: object) => ({
                        ...s,
                        reservationIds: compressToBase64(reservationIds.join(',')),
                    }),
                });
            }
        }
    };
